<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-search-input [disabled]="disabled" #input [label]="label" [(ngModel)]="value" (focussed$)="onFocussed($event)"
                           *ngSwitchDefault [placeholder]="placeholder"></fui-edit-search-input>
    <fui-filter-search-input [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                             (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.FILTER"
                             [placeholder]="placeholder"></fui-filter-search-input>
    <fui-inline-search-input (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.INLINE"></fui-inline-search-input>
    <fui-pop-search-input [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                          (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.POP"
                          [placeholder]="placeholder"></fui-pop-search-input>
    <fui-search-pill [disabled]="disabled" #input [label]="label" [(ngModel)]="value" (focussed$)="onFocussed($event)"
                     [removable]="removable" (removed$)="remove()" [placeholder]="placeholder"
                     *ngSwitchCase="contextType.PILL"></fui-search-pill>
</ng-container>
